var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { AnimatePresence, motion } from "framer";
import { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { CheckIcon } from "../../assets/icons/icons";
import { BaseButton, SecondaryText, Title } from "../../designSystem";
import colors from "../../designSystem/colors";
import sizes from "../../designSystem/sizes";
import theme from "../../designSystem/theme";
import { useBoundingclientrect } from "../../hooks/useBoundingclientrect";
import useOutsideAlerter from "../../hooks/useOutsideAlerter";
import useScreenSize from "../../hooks/useScreenSize";
import ButtonArrow from "./ButtonArrow";
var Filter = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var FilterButton = styled(BaseButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  padding: ", ";\n  background-color: ", ";\n\n  &:hover {\n    background-color: ", ";\n    span {\n      color: ", ";\n    }\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  padding: ", ";\n  background-color: ", ";\n\n  &:hover {\n    background-color: ", ";\n    span {\n      color: ", ";\n    }\n  }\n"])), function (props) {
    return props.config.paddingVertical + "px " + props.config.paddingHorizontal + "px";
}, function (props) {
    return props.active ? props.config.activeBackground : props.config.background;
}, function (props) { return props.config.activeBackground; }, colors.primaryText);
var FilterButtonText = styled(Title)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 14px;\n  color: ", ";\n  text-transform: uppercase;\n"], ["\n  font-size: 14px;\n  color: ", ";\n  text-transform: uppercase;\n"])), function (props) { return props.config.color; });
var FilterDropdownMenu = styled(motion.div)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
    return props.isOpen
        ? "\n          position: absolute;\n          z-index: 2000;\n          padding: 16px;\n          " + (function () {
            switch (props.config.horizontalOrientation) {
                case "left":
                    return "left: 0px;";
                case "right":
                default:
                    return "right: 0px;";
            }
        })() + "\n          " + (function () {
            switch (props.verticalOrientation) {
                case "top":
                    return "bottom: 48px;";
                case "bottom":
                default:
                    return "top: calc(21px + " + props.buttonPaddingVertical * 2 + "px + " + props.config.topBuffer + "px);";
            }
        })() + "\n          width: fit-content;\n          background-color: " + colors.backgroundDarker + ";\n                    border: " + theme.border.width + " " + theme.border.style + " " + colors.border + ";\n          border-radius: " + theme.border.radius + ";\n        "
        : "\n          display: none;\n        ";
});
var MenuItem = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  width: 256px;\n  padding: 14px 16px;\n  opacity: 0.48;\n  border-radius: 100px;\n  background: ", ";\n  margin-bottom: 16px;\n  border: ", " ", " transparent;\n  transition: border 150ms;\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  width: 256px;\n  padding: 14px 16px;\n  opacity: 0.48;\n  border-radius: 100px;\n  background: ", ";\n  margin-bottom: 16px;\n  border: ", " ", " transparent;\n  transition: border 150ms;\n\n  ", "\n"])), function (props) { return props.color + "14"; }, theme.border.width, theme.border.style, function (props) {
    if (props.active) {
        return "\n        opacity: 1;\n        border: " + theme.border.width + " " + theme.border.style + " " + props.color + ";\n      ";
    }
    return "\n      &:hover {\n        opacity: 1;\n      }\n    ";
});
var LogoContainer = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  width: 40px;\n  margin: -12px;\n  margin-right: 8px;\n  background: ", "29;\n  border-radius: 100px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  width: 40px;\n  margin: -12px;\n  margin-right: 8px;\n  background: ", "29;\n  border-radius: 100px;\n"])), function (props) { return props.color; });
var MenuItemText = styled(Title)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  color: ", ";\n  white-space: nowrap;\n  font-size: 14px;\n  line-height: 20px;\n  transition: color 150ms;\n"], ["\n  color: ", ";\n  white-space: nowrap;\n  font-size: 14px;\n  line-height: 20px;\n  transition: color 150ms;\n"])), function (props) { return props.color; });
var StyledCheckButton = styled(CheckIcon)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  path {\n    transition: fill 150ms;\n    stroke: ", ";\n  }\n"], ["\n  path {\n    transition: fill 150ms;\n    stroke: ", ";\n  }\n"])), function (props) { return props.color; });
var SaveButton = styled(BaseButton)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  padding: 12px 24px;\n  margin-top: 24px;\n  background: ", "14;\n  border-radius: ", ";\n"], ["\n  display: flex;\n  justify-content: center;\n  padding: 12px 24px;\n  margin-top: 24px;\n  background: ", "14;\n  border-radius: ", ";\n"])), colors.primaryText, theme.border.radius);
var MultiselectFilterDropdown = function (_a) {
    var values = _a.values, options = _a.options, title = _a.title, onSelect = _a.onSelect, _b = _a.buttonConfig, buttonConfig = _b === void 0 ? {
        background: colors.primaryText + "0A",
        activeBackground: colors.primaryText + "14",
        paddingHorizontal: 16,
        paddingVertical: 12,
        color: "" + colors.primaryText,
    } : _b, _c = _a.dropdownMenuConfig, dropdownMenuConfig = _c === void 0 ? {
        horizontalOrientation: "left",
        topBuffer: 16,
    } : _c, props = __rest(_a, ["values", "options", "title", "onSelect", "buttonConfig", "dropdownMenuConfig"]);
    var ref = useRef(null);
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var _e = useScreenSize(), height = _e.height, width = _e.width;
    var dropdownBoundingRect = useBoundingclientrect(ref);
    var _f = useState(values), selected = _f[0], setSelected = _f[1];
    // Reset selected value if close without save
    useEffect(function () {
        if (!open) {
            setSelected(values);
        }
    }, [open, values]);
    useOutsideAlerter(ref, function () {
        setOpen(false);
    });
    var renderMenuItem = useCallback(function (option) {
        var active = selected.includes(option.value);
        var textColor = option.textColor ? option.textColor : option.color;
        return (_jsxs(MenuItem, __assign({ onClick: function () {
                setSelected(function (currSelected) {
                    return currSelected.includes(option.value)
                        ? currSelected.filter(function (curr) { return curr !== option.value; })
                        : currSelected.concat(option.value);
                });
            }, role: "button", color: option.color, active: active }, { children: [option.logo ? (_jsx(LogoContainer, __assign({ color: option.color }, { children: option.logo }), void 0)) : (_jsx(_Fragment, {}, void 0)), _jsx(MenuItemText, __assign({ color: active ? textColor : colors.primaryText }, { children: option.display }), void 0), active && (_jsx(StyledCheckButton, { color: textColor, className: "ml-auto" }, void 0))] }), option.value));
    }, [selected]);
    var getVerticalOrientation = useCallback(function () {
        /**
         * Height of dropdown: 48px
         * Height of each option: 36px
         * Total dropdown margin: 16px
         */
        if (dropdownBoundingRect &&
            dropdownBoundingRect.top +
                48 +
                options.length * 36 +
                16 +
                (width > sizes.lg
                    ? theme.footer.desktop.height
                    : theme.footer.mobile.height) >
                height) {
            return "top";
        }
        return "bottom";
    }, [width, height, dropdownBoundingRect, options]);
    return (_jsxs(Filter, __assign({}, props, { ref: ref }, { children: [_jsx(FilterButton, __assign({ role: "button", active: open, onClick: function () {
                    setOpen(function (open) { return !open; });
                }, config: buttonConfig }, { children: _jsxs(FilterButtonText, __assign({ config: buttonConfig }, { children: [title, values.length > 0 ? " (" + values.length + ")" : "", " ", _jsx(ButtonArrow, { isOpen: open }, void 0)] }), void 0) }), void 0), _jsx(AnimatePresence, { children: _jsxs(FilterDropdownMenu, __assign({ isOpen: open, verticalOrientation: getVerticalOrientation(), buttonPaddingVertical: buttonConfig.paddingVertical, config: dropdownMenuConfig, initial: {
                        opacity: 0,
                        y: 20,
                    }, animate: {
                        opacity: 1,
                        y: 0,
                    }, exit: {
                        opacity: 0,
                        y: 20,
                    }, transition: {
                        type: "keyframes",
                        duration: 0.2,
                    } }, { children: [options.map(function (filterOption) { return renderMenuItem(filterOption); }), _jsx(SaveButton, __assign({ role: "button", onClick: function () {
                                onSelect(selected);
                                setOpen(false);
                            } }, { children: _jsx(Title, { children: "Save" }, void 0) }), void 0), _jsx("div", __assign({ className: "d-flex w-100 justify-content-center mt-3" }, { children: _jsx(SecondaryText, __assign({ onClick: function () {
                                    return selected.length === options.length
                                        ? setSelected([])
                                        : setSelected(options.map(function (option) { return option.value; }));
                                }, role: "button" }, { children: selected.length === options.length
                                    ? "Deselect All"
                                    : "Select All" }), void 0) }), void 0)] }), open.toString()) }, void 0)] }), void 0));
};
export default MultiselectFilterDropdown;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=MultiselectFilterDropdown.js.map